<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}
        </el-button>
      </el-form-item>
    </el-form>

    <!-- Table -->
    <el-table :data="tableData" stripe highlight-current-row border style="width: 100%"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('empIns7.office_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name1 }}</span>
          <span>{{ scope.row.name2 }}</span>
          <span>{{ scope.row.name3 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns7.chairman_name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.chairman }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns7.abo_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.abolish_date }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns7.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- add -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="72%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="210px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />
        <el-collapse accordion>
          <el-collapse-item :title="$t('empIns7.abo_info')" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('companyInfo.name')+':'" prop="name1" style="margin-left:50px">
                    <el-select v-model="ruleForm.name1" style="margin-left:10px;margin-right:50px;width: 185px"
                      size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns7.date')"
                      :default-value="new Date('2020-05-03')"></el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.abo_category')" style="margin-left:50px">
                    <el-select v-model="ruleForm.abolish_dvd" :placeholder="$t('general.select')" clearable size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in abolish_dvd" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.establish_no')" prop="business_code"
                    v-if="ruleForm.abolish_dvd === '4. 事業所の統合に伴う事業所の廃止'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.business_code" size="mini" :maxlength="13"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns7.establish_no')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="businessHint"></el-button>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.abo_reason')" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns7.abo_reason')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item>
                    <br />
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.abo_date')" prop="abolish_date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.abolish_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns7.abo_date')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.establish_date')" prop="business_date"
                    v-if="ruleForm.abolish_dvd === '4. 事業所の統合に伴う事業所の廃止'" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.business_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns7.establish_date')">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->

    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="72%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="210px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />
        <el-collapse accordion>
          <el-collapse-item :title="$t('empIns7.company_info')" name="1">
            <el-row>
              <p style="color: red; font-size: 15px; font-weight: 200;">
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;{{$t("empIns7.cant_change")}}</p>
            </el-row>
            <el-row>
              <el-form-item :label="$t('empIns7.office_name')" prop="name1" style="margin-left:50px">
                <el-input prefix-icon="el-icon-info" :value="ruleForm.name1" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 500px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns7.address')" prop="address" style="margin-left:50px">
                <el-input prefix-icon="el-icon-info"
                  :value="'〒'+ruleForm.postal_code+'  '+ruleForm.address1+ruleForm.address2+ruleForm.address3"
                  size="mini" readonly="readonly" style="margin-left:10px;width: 500px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns7.chairman_name')" prop="chairman" style="margin-left:50px">
                <el-input prefix-icon="el-icon-info" :value="ruleForm.chairman" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns7.tel')" prop="tel" style="margin-left:50px">
                <el-input prefix-icon="el-icon-info" :value="ruleForm.tel" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 185px"></el-input>
              </el-form-item>
            </el-row>
          </el-collapse-item>
          <el-collapse-item :title="$t('empIns7.abo_info')" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('empIns7.date')" prop="date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns7.date')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.abo_category')" style="margin-left:50px">
                    <el-select v-model="ruleForm.abolish_dvd" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in abolish_dvd" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.establish_no')" prop="business_code"
                    v-if="ruleForm.abolish_dvd === '4. 事業所の統合に伴う事業所の廃止'" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.business_code" size="mini" :maxlength="13"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns7.establish_no')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="businessHint"></el-button>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.abo_reason')" prop="reason" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reason" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('empIns7.reason')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item>
                    <br />
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.abo_date')" prop="abolish_date" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.abolish_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns7.abo_date')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('empIns7.establish_date')" prop="business_date"
                    v-if="ruleForm.abolish_dvd === '4. 事業所の統合に伴う事業所の廃止'" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.business_date" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empIns7.establish_date')">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        value: "",
        currentDate: new Date("2020-05-03"),
        ruleForm: {
          id: "",
          abolish_date: "",
          abolish_dvd: "",
          business_code: "",
          business_date: "",
          date: "",
          reason: "",
          name1: "",
        },
        abolish_dvd: [{
            value: "1. 事業所の廃止",
            label: this.$t("empIns7.category1"),
          },
          {
            value: "4. 事業所の統合に伴う事業所の廃止",
            label: this.$t("empIns7.category2"),
          },
        ],
        rules: {
          abolish_date: [{
            required: true,
            message: this.$t("empIns7.abo_dateRule"),
            trigger: "blur",
          }, ],
          business_code: [{
            required: true,
            message: this.$t("empIns7.business_codeRule"),
            trigger: "blur",
          }, ],
          business_date: [{
            required: true,
            message: this.$t("empIns7.business_dateRule"),
            trigger: "blur",
          }, ],
          date: [{
              required: true,
              message: this.$t("empIns7.dateRule"),
              trigger: "blur",
            },
            {
              whitespace: "emptyAlert();",
            },
          ],
          name1: [{
            required: true,
            message: "入力してください",
            trigger: "blur",
          }, ],
        },
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
        companyInfo: [],
      };
    },
    methods: {
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open(
          "/pdf/雇用保険適用事業所廃止届-" + row.date + "uid=" + uid + ".pdf"
        );
      },
      businessHint() {
        this.$notify.info({
          title: this.$t("empIns7.businessHintTitle"),
          message: this.$t("empIns7.businessHintMsg"),
        });
      },
      emptyAlert() {
        this.$notify.error({
          title: this.$t("empIns7.emptyAlertTitle"),
          message: this.$t("empIns7.emptyAlertMsg"),
        });
      },

      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id,
        });
        this.axios({
            method: "post",
            url: "/empIns7PDF",
            data: postData,
          })
          .then((response) => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 300);
          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: this.$t("general.confirm"),
            cancelButtonText: this.$t("general.cancel"),
            type: "warning"
          })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => {});
      },
      handleDelete(index, row) {
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: "OK",
            cancelButtonText: this.$t("general.cancel"),
            type: "warning",
          })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
                method: "post",
                url: "/deleteEmpIns7",
                data: postData,
              })
              .then((response) => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageEmpIns7")
                  .then((response) => {
                    this.tableData = response.data;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });
      },
      handleCurrentChange() {
        let postData = this.qs.stringify({
          page: this.currentPage,
        });
        this.axios({
            method: "post",
            url: "/pageEmpIns7",
            data: postData,
          })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          abolish_date: "",
          abolish_dvd: "",
          business_code: "",
          business_date: "",
          date: "",
          reason: "",
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              abolish_date: this.ruleForm.abolish_date,
              abolish_dvd: this.ruleForm.abolish_dvd,
              business_code: this.ruleForm.business_code,
              business_date: this.ruleForm.business_date,
              date: this.ruleForm.date,
              reason: this.ruleForm.reason,
            });
            this.axios({
                method: "post",
                url: "/insertEmpIns7",
                data: postData,
              })
              .then((response) => {
                this.axios
                  .post("/pageEmpIns7")
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.cancel();
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              abolish_date: this.ruleForm.abolish_date,
              abolish_dvd: this.ruleForm.abolish_dvd,
              business_code: this.ruleForm.business_code,
              business_date: this.ruleForm.business_date,
              date: this.ruleForm.date,
              reason: this.ruleForm.reason,
            });
            this.axios({
                method: "post",
                url: "/updateEmpIns7",
                data: postData,
              })
              .then((response) => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsEmpIns7")
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
    },
    created() {
      this.axios
        .post("/pageEmpIns7")
        .then((response) => {
          // console.log(response.data);
          this.show = true;
          this.tableData = response.data;
        })
        .catch((error) => {
          // this.show = false;
          // this.$message({
          //   type: 'error',
          //   message: '開発中です。'
          // });
          // console.log(error);
        });

      this.axios
        .post("/rowsEmpIns7")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.axios
        .post("/ListComInfo")
        .then((response) => {
          // console.log(response.data);
          this.companyInfo = response.data;
          // console.log(this.companyInfo);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns7.vue